import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import React, { Fragment, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import rectangularimg from "../../../images/area-rectangle.gif";
import triangleimg from "../../../images/area-triangle.gif";
import trapezoidimg from "../../../images/area-trapezoid.gif";
import circleimg from "../../../images/area-circle.gif";
import sectorimg from "../../../images/area-sector.gif";
import ellipseimg from "../../../images/area-ellipse.gif";
import parallelogramimg from "../../../images/area-parallelogram.gif";
const TITLE = "حساب مساحة الاشكال الهندسية - حاسبة المساحة";
const DESCRIPTION =
  "هذه الحاسبة تقوم بحساب مساحة عدة أشكال هندسية شائعة، بما في ذلك المستطيل، والمثلث، والمتوازي الأضلاع، والدائرة، والقطاع، الشكل البيضوي.";
const KEYWORDS =
  "حاسبة مساحة، أشكال هندسية، حساب, شكل هندسي, مستطيل، مثلث، متوازي الأضلاع، دائرة، قطاع، متوازي الأضلاع";
const OG_URL = "https://do-calculate.com/calculator/ar/areas";
const conversionMap = {
  سنتيمتر: 0.01,
  بوصة: 0.0254,
  متر: 1,
  كيلومتر: 1000,
  قدم: 0.3048,
  ميل: 1609.34,
};

const selectStyle = {
  width: "auto",
  display: "inline-block",
  marginLeft: "5px",
  backgroundColor: "#f9f9f9",
}
const rectangularSchema = yup.object().shape({
  length: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  width: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialRectangularValues = {
  length: "",
  width: "",
  lengthUnit: "متر",
  widthUnit: "متر",
};
const triangleSchema = yup.object().shape({
  edge1: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  edge2: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  edge3: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialTriangleValues = {
  edge1: "",
  edge2: "",
  edge3: "",
  edge1Unit: "متر",
  edge2Unit: "متر",
  edge3Unit: "متر",
};
const trapezoidSchema = yup.object().shape({
  base1: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  base2: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialTrapezoidValues = {
  base1: "",
  base2: "",
  height: "",
  base1Unit: "متر",
  base2Unit: "متر",
  heightUnit: "متر",
};
const circleSchema = yup.object().shape({
  radius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialCircleValues = {
  radius: "",
  radiusUnit: "متر",
};
const sectorSchema = yup.object().shape({
  radius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  angle: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(360, " يرجى ادخال اعداد بين 0 و 360")
    .min(0, " يرجى ادخال اعداد موجبة بين 0 و 360"),
});
const initialSectorValues = {
  radius: "",
  angle: "",
  radiusUnit: "متر",
};
const ellipseSchema = yup.object().shape({
  semiMajorAxes: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  semiMinorAxes: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialEllipseValues = {
  semiMajorAxes: "",
  semiMinorAxes: "",
  semiMajorAxesUnit: "متر",
  semiMinorAxesUnit: "متر",
};
const parallelogramSchema = yup.object().shape({
  base: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialParallelogramValues = {
  base: "",
  height: "",
  baseUnit: "متر",
  heightUnit: "متر",
};
const AreaCalculators = () => {
  const [rectangularArea, setRectangularArea] = useState("");
  const [convertedRectangularUnit, setConvertedRectangularUnit] =
    useState("متر");
  const onSubmitRectangular = (values) => {
    const { length, width, lengthUnit, widthUnit } = values;
    let convertedLength = length;
    let convertedWidth = width;
    let resultUnit = "";
    if (conversionMap[lengthUnit] >= conversionMap[widthUnit]) {
      resultUnit = lengthUnit;
    } else {
      resultUnit = widthUnit;
    }
    if (resultUnit !== lengthUnit) {
      convertedLength =
        (length * conversionMap[lengthUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== widthUnit) {
      convertedWidth =
        (width * conversionMap[widthUnit]) / conversionMap[resultUnit];
    }
    const rectangularArea = convertedLength * convertedWidth;
    setRectangularArea(rectangularArea);
    setConvertedRectangularUnit(resultUnit);
  };
  const [triangleArea, setTriangleArea] = useState("");
  const [convertedTriangleUnit, setConvertedTriangleUnit] = useState("m");
  const [errorMessage, setErrorMessage] = useState("");
  const onSubmitTriangle = (values) => {
    const { edge1, edge2, edge3, edge1Unit, edge2Unit, edge3Unit } = values;
    const convertedEdges = [
      edge1 * conversionMap[edge1Unit],
      edge2 * conversionMap[edge2Unit],
      edge3 * conversionMap[edge3Unit],
    ];
    const maxUnitValue = Math.max(
      conversionMap[edge1Unit],
      conversionMap[edge2Unit],
      conversionMap[edge3Unit]
    );
    const resultUnit = Object.keys(conversionMap).find(
      (key) => conversionMap[key] === maxUnitValue
    );
    const convertedEdgesNormalized = convertedEdges.map(
      (edge) => edge / maxUnitValue
    );
    if (
      convertedEdgesNormalized[2] <
      convertedEdgesNormalized[0] + convertedEdgesNormalized[1]
    ) {
      const p =
        (convertedEdges[0] + convertedEdges[1] + convertedEdges[2]) /
        (2 * maxUnitValue);
      const triangleArea = Math.sqrt(
        p *
        (p - convertedEdgesNormalized[0]) *
        (p - convertedEdgesNormalized[1]) *
        (p - convertedEdgesNormalized[2])
      );
      const convertedArea = triangleArea;
      setTriangleArea(convertedArea);
      setConvertedTriangleUnit(resultUnit);
      setErrorMessage("");
    } else {
      setTriangleArea("");
      setConvertedTriangleUnit("");
      setErrorMessage("مجموع اي حافتين لايجب ان يكون اكبر من الثالثة");
    }
  };
  const [trapezoidArea, setTrapezoidArea] = useState("");
  const [convertedTrapezoidUnit, setConvertedTrapezoidUnit] = useState("متر");
  const onSubmitTrapezoid = (values) => {
    const { base1, base2, height, base1Unit, base2Unit, heightUnit } = values;
    let convertedBase1 = base1;
    let convertedBase2 = base2;
    let convertedHeight = height;
    let resultUnit = "";
    if (
      conversionMap[base1Unit] >= conversionMap[base2Unit] &&
      conversionMap[base1Unit] >= conversionMap[heightUnit]
    ) {
      resultUnit = base1Unit;
    } else if (
      conversionMap[base2Unit] >= conversionMap[base1Unit] &&
      conversionMap[base2Unit] >= conversionMap[heightUnit]
    ) {
      resultUnit = base2Unit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== base1Unit) {
      convertedBase1 =
        (base1 * conversionMap[base1Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== base2Unit) {
      convertedBase2 =
        (base2 * conversionMap[base2Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const trapezoidArea =
      ((Number(convertedBase1) + Number(convertedBase2)) / 2) * convertedHeight;
    setTrapezoidArea(trapezoidArea);
    setConvertedTrapezoidUnit(resultUnit);
  };
  const [circleArea, setCircleArea] = useState("");
  const [convertedCircleUnit, setConvertedCircleUnit] = useState("متر");
  const onSubmitCircle = (values) => {
    const { radius, radiusUnit } = values;
    const circleArea = Math.PI * Math.pow(radius, 2);
    setCircleArea(circleArea);
    setConvertedCircleUnit(radiusUnit);
  };
  const [sectorArea, setSectorArea] = useState("");
  const [convertedSectorUnit, setConvertedSectorUnit] = useState("متر");
  const onSubmitSector = (values) => {
    const { radius, angle, radiusUnit } = values;
    const sectorArea = (angle / 360) * Math.PI * Math.pow(radius, 2);
    setSectorArea(sectorArea);
    setConvertedSectorUnit(radiusUnit);
  };
  const [ellipseArea, setEllipseArea] = useState("");
  const [convertedEllipseUnit, setConvertedEllipseUnit] = useState("متر");
  const onSubmitEllipse = (values) => {
    const {
      semiMajorAxes,
      semiMinorAxes,
      semiMajorAxesUnit,
      semiMinorAxesUnit,
    } = values;
    let convertedSemiMajorAxes = semiMajorAxes;
    let convertedSemiMinorAxes = semiMinorAxes;
    let resultUnit = "";
    if (conversionMap[semiMajorAxesUnit] >= conversionMap[semiMinorAxesUnit]) {
      resultUnit = semiMajorAxesUnit;
    } else {
      resultUnit = semiMinorAxesUnit;
    }
    if (resultUnit !== semiMajorAxesUnit) {
      convertedSemiMajorAxes =
        (semiMajorAxes * conversionMap[semiMajorAxesUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== semiMinorAxesUnit) {
      convertedSemiMinorAxes =
        (semiMinorAxes * conversionMap[semiMinorAxesUnit]) /
        conversionMap[resultUnit];
    }
    const ellipseArea =
      Math.PI * convertedSemiMajorAxes * convertedSemiMinorAxes;
    setEllipseArea(ellipseArea);
    setConvertedEllipseUnit(resultUnit);
  };
  const [parallelogramArea, setParallelogramArea] = useState("");
  const [convertedParallelogramUnit, setConvertedParallelogramUnit] =
    useState("متر");
  const onSubmitParallelogram = (values) => {
    const { base, height, baseUnit, heightUnit } = values;
    let convertedBase = base;
    let convertedHeight = height;
    let resultUnit = "";
    if (conversionMap[baseUnit] >= conversionMap[heightUnit]) {
      resultUnit = baseUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== baseUnit) {
      convertedBase =
        (base * conversionMap[baseUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const parallelogramArea = convertedBase * convertedHeight;
    setParallelogramArea(parallelogramArea);
    setConvertedParallelogramUnit(resultUnit);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p>
                المساحة هي كمية تصف حجم أو مدى شكل ثنائي الأبعاد أو شكل في
                مستوى. يمكن تصورها على أنها كمية الطلاء اللازمة لتغطية سطح، وهي
                نظيرة ثنائية الأبعاد للطول الواحد للمنحنى، وحجم الكتلة ثلاثية
                الأبعاد. الوحدة القياسية للمساحة في النظام الدولي للوحدات (SI)
                هي المتر المربع، أو m<sup>2</sup>. فيما يلي معادلات لبعض الأشكال
                البسيطة الأكثر شيوعًا، وأمثلة على كيفية حساب مساحة كل منها.
              </p>
              <h2 style={{ fontSize: "17px" }}>
                يتم حساب مساحة الأشكال الهندسية بالطريقة التالية
              </h2>
              <ul>
                <li>مساحة المستطيل: لحساب مساحة المستطيل نضرب الطول بالعرض</li>
                <li>
                  مساحة المثلث ذو الثلاث جوانب: نقوم بحسابه حسب صيغة هيرون
                  (Heron’s Formula):
                  <br />
                  s(s-a)(s-b)(s-c)√
                  <br />s =(a+b+c) / 2
                </li>
                <li>
                  مساحة المضلع شبه المنحرف: نقوم بحساب مساحة المضلع شبه المنحرف
                  حسب الصيغة التالية: (2/ (b1 + b2))× h
                </li>
                <li>
                  مساحة الدائرة: لحساب مساحة الدائرة نضرب π بنصف القطر مرفوع
                  للتربيع
                </li>
                <li>
                  مساحة القطاع: نقوم بحساب مساحة القطاع حسب الصيغة التالية:
                  (الزاوية /360) × π × نصف القطر مرفوع للتربيع
                </li>
                <li>
                  مساحة الشكل البيضوي: نقوم بحساب مساحة الشكل البيضوي حسب الصيغة
                  التالية: المساحة = πab
                </li>
                <li>
                  مساحة متوازي الاضلاع: نقوم بحساب مساحة متوازي الاضلاع بضرب
                  القاعدة بالارتفاع
                </li>
              </ul>
              <b>
                يمكنك أيضا استخدام الحاسبة التالية لحساب مساحة الأشكال الهندسية:
              </b>
              <hr />
            </div>
            <MobileUnderCalAds />
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialRectangularValues}
                validationSchema={rectangularSchema}
                onSubmit={onSubmitRectangular}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة المستطيل - حاسبة مساحة المستطيل
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="length"
                          value={formik.values.length}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الطول"
                          className="form-control"
                        />
                        {formik.touched.length && formik.errors.length && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.length}
                          </div>
                        )}
                      </div>
                      <select
                        name="lengthUnit"
                        value={formik.values.lengthUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="width"
                          value={formik.values.width}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="العرض"
                          className="form-control"
                        />
                        {formik.touched.width && formik.errors.width && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.width}
                          </div>
                        )}
                      </div>
                      <select
                        name="widthUnit"
                        value={formik.values.widthUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setRectangularArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {rectangularArea && rectangularArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة المستطيل هو : {rectangularArea}{" "}
                          {convertedRectangularUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة المستطيل - حاسبة مساحة المستطيل"
                src={rectangularimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialTriangleValues}
                validationSchema={triangleSchema}
                onSubmit={onSubmitTriangle}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة المثلث - حاسبة مساحة المثلث
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="edge1"
                          value={formik.values.edge1}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الحافة 1"
                          className="form-control"
                        />
                        {formik.touched.edge1 && formik.errors.edge1 && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.edge1}
                          </div>
                        )}
                      </div>
                      <select
                        name="edge1Unit"
                        value={formik.values.edge1Unit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="edge2"
                          value={formik.values.edge2}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الحافة 2"
                          className="form-control"

                        />
                        {formik.touched.edge2 && formik.errors.edge2 && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.edge2}
                          </div>
                        )}
                      </div>
                      <select
                        name="edge2Unit"
                        value={formik.values.edge2Unit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="edge3"
                          value={formik.values.edge3}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الحافة 3"
                          className="form-control"
                        />
                        {formik.touched.edge3 && formik.errors.edge3 && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.edge3}
                          </div>
                        )}
                      </div>
                      <select
                        name="edge3Unit"
                        value={formik.values.edge3Unit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setTriangleArea(null);
                          formik.resetForm();
                          setErrorMessage("");
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {errorMessage && (
                      <p className="p-3 mb-2 bg-danger text-white">
                        {errorMessage}
                      </p>
                    )}
                    {triangleArea && triangleArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة المثلث هو : {triangleArea}{" "}
                          {convertedTriangleUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة المثلث - حاسبة مساحة المثلث"
                src={triangleimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialTrapezoidValues}
                validationSchema={trapezoidSchema}
                onSubmit={onSubmitTrapezoid}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة المضلع شبه المنحرف - حاسبة مساحة المضلع
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="base1"
                          value={formik.values.base1}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="القاعدة 1"
                          className="form-control"
                        />
                        {formik.touched.base1 && formik.errors.base1 && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.base1}
                          </div>
                        )}
                      </div>
                      <select
                        name="base1Unit"
                        value={formik.values.base1Unit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="base2"
                          value={formik.values.base2}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="القاعدة 2"
                          className="form-control"
                        />
                        {formik.touched.base2 && formik.errors.base2 && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.base2}
                          </div>
                        )}
                      </div>
                      <select
                        name="base2Unit"
                        value={formik.values.base2Unit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="height"
                          value={formik.values.height}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الارتفاع"
                          className="form-control"
                        />
                        {formik.touched.height && formik.errors.height && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.height}
                          </div>
                        )}
                      </div>
                      <select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setTrapezoidArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {trapezoidArea && trapezoidArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة المضلع شبه المنحرف هو :{" "}
                          {trapezoidArea} {convertedTrapezoidUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة المضلع شبه المنحرف - حاسبة مساحة المضلع"
                src={trapezoidimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialCircleValues}
                validationSchema={circleSchema}
                onSubmit={onSubmitCircle}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة الدائرة - حاسبة مساحة الدائرة
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="radius"
                          value={formik.values.radius}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="القطر"
                          className="form-control"
                        />
                        {formik.touched.radius && formik.errors.radius && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.radius}
                          </div>
                        )}
                      </div>
                      <select
                        name="radiusUnit"
                        value={formik.values.radiusUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setCircleArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {circleArea && circleArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة الدائرة هو : {circleArea}{" "}
                          {convertedCircleUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة الدائرة - حاسبة مساحة الدائرة"
                src={circleimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialSectorValues}
                validationSchema={sectorSchema}
                onSubmit={onSubmitSector}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة القطاع - حاسبة مساحة القطاع
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="radius"
                          value={formik.values.radius}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="القطر"
                          className="form-control"
                        />
                        {formik.touched.radius && formik.errors.radius && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.radius}
                          </div>
                        )}
                      </div>
                      <select
                        name="radiusUnit"
                        value={formik.values.radiusUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className="mb-3"
                      style={{ display: "flex", alignItems: "baseline" }}
                    >
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="angle"
                          value={formik.values.angle}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الزاوية"
                          className="form-control"
                        />
                        {formik.touched.angle && formik.errors.angle && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.angle}
                          </div>
                        )}
                      </div>
                      <p
                        style={{
                          borderRadius: "4px",
                          border: " 1px solid rgba(0, 0, 0, 0.23)",
                          backgroundColor: "#f9f9f9",
                          padding: "6.5px 18px 6.5px 15px",
                          userSelect: "none",
                        }}
                      >
                        ° درجة
                      </p>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setSectorArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {sectorArea && sectorArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة القطاع هو : {sectorArea}{" "}
                          {convertedSectorUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة القطاع - حاسبة مساحة القطاع"
                src={sectorimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialEllipseValues}
                validationSchema={ellipseSchema}
                onSubmit={onSubmitEllipse}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة الشكل البيضوي - حاسبة مساحة الشكل البيضوي
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="semiMajorAxes"
                          value={formik.values.semiMajorAxes}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="محور القطر الأكبر"
                          className="form-control"
                        />
                        {formik.touched.semiMajorAxes && formik.errors.semiMajorAxes && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.semiMajorAxes}
                          </div>
                        )}
                      </div>
                      <select
                        name="semiMajorAxesUnit"
                        value={formik.values.semiMajorAxesUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="semiMinorAxes"
                          value={formik.values.semiMinorAxes}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="محور القطر الصغري"
                          className="form-control"
                        />
                        {formik.touched.semiMinorAxes && formik.errors.semiMinorAxes && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.semiMinorAxes}
                          </div>
                        )}
                      </div>
                      <select
                        name="semiMinorAxesUnit"
                        value={formik.values.semiMinorAxesUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setEllipseArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {ellipseArea && ellipseArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة الشكل البيضوي هو : {ellipseArea}{" "}
                          {convertedEllipseUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة الشكل البيضوي - حاسبة مساحة الشكل البيضوي"
                src={ellipseimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialParallelogramValues}
                validationSchema={parallelogramSchema}
                onSubmit={onSubmitParallelogram}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب مساحة متوازي الاضلاع - حاسبة مساحة متوازي الاضلاع
                      </h3>
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="base"
                          value={formik.values.base}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="القاعدة"
                          className="form-control"
                        />
                        {formik.touched.base && formik.errors.base && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.base}
                          </div>
                        )}
                      </div>
                      <select
                        name="baseUnit"
                        value={formik.values.baseUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <div style={{ width: "160px", marginLeft: "10px", display: "inline-block" }}>
                        <input
                          type="text"
                          name="height"
                          value={formik.values.height}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="الارتفاع"
                          className="form-control"
                        />
                        {formik.touched.height && formik.errors.height && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {formik.errors.height}
                          </div>
                        )}
                      </div>
                      <select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        className="form-control"
                        style={selectStyle}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <option key={unit} value={unit}>
                            {unit}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        disabled={!formik.isValid}
                        className="btn btn-success"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                      >
                        إحسب
                      </button>
                      <button
                        type="button"
                        disabled={!formik.isValid}
                        className="btn btn-secondary"
                        style={{
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                        }}
                        onClick={() => {
                          setParallelogramArea(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </button>
                    </div>
                    {parallelogramArea && parallelogramArea > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : مساحة متوازي الاضلاع هو :{" "}
                          {parallelogramArea} {convertedParallelogramUnit}
                          <sup>2</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب مساحة متوازي الاضلاع - حاسبة مساحة متوازي الاضلاع"
                src={parallelogramimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>المساحة</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                المساحة هي كمية تصف حجم أو مدى شكل ثنائي الأبعاد أو شكل في
                مستوى. يمكن تصورها على أنها كمية الطلاء اللازمة لتغطية سطح، وهي
                نظيرة ثنائية الأبعاد للطول الواحد للمنحنى، وحجم الكتلة ثلاثية
                الأبعاد. الوحدة القياسية للمساحة في النظام الدولي للوحدات (SI)
                هي المتر المربع، أو m<sup>2</sup>. فيما يلي معادلات لبعض الأشكال
                البسيطة الأكثر شيوعًا، وأمثلة على كيفية حساب مساحة كل منها.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>حساب مساحة المستطيل</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                المستطيل هو رباعي ذو أربع زوايا قائمة. إنه من أبسط الأشكال،
                وحساب مساحته يتطلب فقط معرفة طوله وعرضه (أو يمكن قياسه). يعتبر
                رباعيًا بناءً على التعريف الذي يشير إلى أنه مضلع يحتوي على أربعة
                حواف ورؤوس. في حالة المستطيل، يشير الطول عادة إلى الحافة الأطول
                من الحواف الأربعة، بينما يشير العرض إلى الحافة الأقصر من بين
                الحواف الاثنين. عندما تكون الطول والعرض متساويين، يكون الشكل
                حالة خاصة من المستطيل تسمى مربعًا. المعادلة لحساب مساحة المستطيل
                هي كالتالي:
              </p>
              <p>
                <strong>المساحة = الطول × العرض</strong>
              </p>
              <p>
                على سبيل المثال، إذا كانت طول المستطيل 10 أمتار والعرض 5 أمتار:
              </p>
              <code>
                مساحة = 10 م × 5 م = 50 م<sup>2</sup>
              </code>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>حساب مساحة المثلث</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                هناك العديد من المعادلات لحساب مساحة المثلث استنادًا إلى
                المعلومات المتاحة. كما ذكر في الآلة الحاسبة أعلاه، يرجى استخدام
                آلة حاسبة المثلث للحصول على مزيد من التفاصيل والمعادلات لحساب
                مساحة المثلث، بالإضافة إلى تحديد أضلاع المثلث باستخدام أي
                معلومات متاحة. باختصار، المعادلة المستخدمة في الآلة الحاسبة
                المقدمة أعلاه تُعرف باسم "صيغة هيرون"، وتشير إلى هيرون من
                الإسكندرية، عالم الرياضيات والمهندس اليوناني الذي يُعتبر من قبل
                البعض أعظم محاول في العصور القديمة. المعادلة هي كالتالي:
              </p>
              <p>
                <strong>المساحة = √s(s - x)(s - y)(s - z)</strong>
              </p>
              <p>حيث:</p>
              <p>
                <strong>s = (x + y + z) / 2</strong>
              </p>
              <p>وٍ</p>
              <p>
                <strong>x، y، z</strong> هي أضلاع المثلث
              </p>
              <p>
                على سبيل المثال، إذا كان لديك مثلث وأطوال ضوابطه هي 7 متر، 9
                متر، و 12 متر:
              </p>
              <code>s = (7 م + 9 م + 12 م) / 2 = 14 م</code>
              <code>
                مساحة = √14 × (14 - 7) × (14 - 9) × (14 - 12) = 21 م<sup>2</sup>
              </code>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>حساب مساحة الدائرة</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                الدائرة هي شكل مغلق بسيط يتكون من مجموعة من جميع النقاط في مستوى
                تكون على مسافة معينة من نقطة مركزية معينة. تسمى هذه المسافة من
                المركز إلى أي نقطة على الدائرة بالنصف قطر. يمكن العثور على مزيد
                من التفاصيل بشأن الدوائر على صفحة حاسبة الدائرة، ولكن لحساب
                المساحة، يكفي أن نعرف النصف القطر، وأن نفهم أن القيم في الدائرة
                ترتبط من خلال الثابت الرياضي π. المعادلة لحساب مساحة الدائرة هي
                كالتالي:
              </p>
              <p>
                مساحة = π × (نصف القطر)<sup>2</sup>
              </p>
              <p>على سبيل المثال، إذا كان لديك دائرة ونصف قطرها 10 متر:</p>
              <code>
                مساحة = π × (10 م)<sup>2</sup> = 100π م<sup>2</sup>
              </code>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>حساب مساحة القطاع</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                القطاع في الدائرة هو أساسًا نسبة من الدائرة محصورة بين شعاعين
                وقوس. باستخدام القطر والزاوية، يمكن حساب مساحة القطاع عن طريق
                ضرب مساحة الدائرة بنسبة الزاوية المعروفة إلى 360° أو 2π راديان،
                كما هو موضح في المعادلة التالية:
              </p>
              <p>
                مساحة = (θ / 360) × π × (نصف القطر)² إذا كانت الزاوية θ بالدرجات
              </p>
              <p>أو</p>
              <p>
                مساحة = (θ / 2π) × π × (نصف القطر)² إذا كانت الزاوية θ بالراديان
              </p>
              <p>
                نتيجة للاستهتار بواسطة بلاسيبوس، يحصل كل شخص على ثلث أقل من
                الفطيرة، وتتذكر الابنة بتأمل تاريخ أمريكا، حيث تعلمت عن معركة
                الآلامو وتصوير البطل الشعبي ديفي كروكيت وقبعته المصنوعة من فرو
                الراكون.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>حساب متوازي الاضلاع</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                المتوازي الستوي هو رباعي بسيط يحتوي على زوجين من الأضلاع
                المتوازية، حيث تكون الأضلاع والزوايا المتقابلة للرباعي متساوية
                في الطول والزاوية. المستطيل، واللوز، والمربع هي جميعها حالات
                خاصة من المتوازي الستوي. تذكر أن تصنيف الشكل "البسيط" يعني أن
                الشكل ليس متقاطعًا. يمكن تقسيم المتوازي الستوي إلى مثلث قائم
                وشكل شبه متوازي، يمكن إعادة ترتيبه لتشكيل مستطيل، مما يجعل
                المعادلة لحساب مساحة المتوازي الستوي تقريبًا نفس تلك المستخدمة
                لحساب المستطيل. عوضًا عن الطول والعرض، يستخدم المتوازي الستوي
                القاعدة والارتفاع، حيث يكون الارتفاع هو طول العمود الرأسي بين
                زوج من القواعد. استنادًا إلى الشكل أدناه، فإن المعادلة لحساب
                مساحة المتوازي الستوي هي كما يلي:
              </p>
              <code>مساحة = القاعدة × الارتفاع</code>
              <p>
                على سبيل المثال، إذا كان لديك متوازي الأضلاع والقاعدة 15 متر
                والارتفاع 10 متر:
              </p>
              <code>
                مساحة = 15 م × 10 م = 150 م<sup>2</sup>
              </code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AreaCalculators;
